class FullOutfit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.itemsOutfit = this.querySelectorAll('.item-outfit');
      this.addButtonOutfit = this.querySelector('.add-button-outfit');
      this.previousTextOutfit = 'ADD SELECTED ITEMS';
      this.messageContainer = this.querySelector(".return-msg-outfit")

      this.addButtonOutfit.addEventListener('click', this.handleBtnClickEvent.bind(this));
      this.updateButtonStateOutfit();

      // Update button on changes
      this.querySelectorAll('input[type="checkbox"], .size-select-outfit').forEach((el) => {
        el.addEventListener('change', this.updateButtonStateOutfit.bind(this));
      });
    }

    updateButtonStateOutfit() {
      const checkedCountOutfit = Array.from(this.itemsOutfit).filter(
        (itemOutfit) => itemOutfit.querySelector('input[type="checkbox"]').checked
      ).length;

      let tp = 0;
      let tcp = 0;

      this.itemsOutfit.forEach((itemOutfit) => {
        const checkboxOutfit = itemOutfit.querySelector('input[type="checkbox"]');
        if (checkboxOutfit.checked) {
          const sizeSelectOutfit = itemOutfit.querySelector('input[type="radio"]:checked');
          
          const p = parseFloat(sizeSelectOutfit?.dataset?.price)
          const cp = parseFloat(sizeSelectOutfit?.dataset?.comparePrice)
          
          tp += p;
          tcp += cp;
        }
      });

      if (checkedCountOutfit > 0) {
        this.addButtonOutfit.classList.add('enabled-outfit');
        if (!this.addButtonOutfit.classList.contains('loading-outfit')) {
          this.addButtonOutfit.querySelector(".regular-price").textContent = Shopify.moneyFormat?.replace("{{amount}}",new Intl.NumberFormat(Shopify.country).format(tp))
          this.addButtonOutfit.querySelector(".compare-price").textContent = Shopify.moneyFormat?.replace("{{amount}}",new Intl.NumberFormat(Shopify.country).format(tcp))
        }
      } else {
        this.addButtonOutfit.classList.remove('enabled-outfit');
        if (!this.addButtonOutfit.classList.contains('loading-outfit')) {
          this.addButtonOutfit.querySelector(".btn-label").textContent = 'ADD BUNDLE TO CART';
          this.addButtonOutfit.querySelector(".regular-price").textContent = Shopify.moneyFormat?.replace("{{amount}}",new Intl.NumberFormat(Shopify.country).format(tp))
          this.addButtonOutfit.querySelector(".compare-price").textContent = Shopify.moneyFormat?.replace("{{amount}}",new Intl.NumberFormat(Shopify.country).format(tcp))
        }
      }
    }

    handleBtnClickEvent(event) {
      if (!this.addButtonOutfit.classList.contains('enabled-outfit')) return;

      // Start loading state
      this.addButtonOutfit.classList.remove('enabled-outfit');
      this.addButtonOutfit.classList.add('loading-outfit');
      this.addButtonOutfit.querySelector(".btn-label").textContent = 'ADDING...';

      // Build cart array
      const cartArrayOutfit = [];
      this.itemsOutfit.forEach((itemOutfit) => {
        const checkboxOutfit = itemOutfit.querySelector('input[type="checkbox"]');
        if (checkboxOutfit.checked) {
          const sizeSelectOutfit = itemOutfit.querySelector('input[type="radio"]:checked');
          const selectedIdOutfit = sizeSelectOutfit.value;

          cartArrayOutfit.push({
            id: selectedIdOutfit,
            quantity: 1,
          });
        }
      });

      let formData = {
        items: cartArrayOutfit,
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
            if(response?.message) {
                this.messageContainer.textContent = response?.message
                upcartCloseCart()
                alert(response?.message)
                setTimeout(() => upcartCloseCart(), 1000)
            }
        })
        .catch((error) => {
            this.messageContainer.textContent = "Something went wrong! please try again later."
            upcartCloseCart()
            console.error('##### Error:', error);
        })
        .finally(() => {
          this.addButtonOutfit.classList.remove('loading-outfit');
          this.updateButtonStateOutfit(); // Restore correct text and state
          setTimeout(() => {
            this.messageContainer.textContent = ""
          }, 10000);
        });
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    customElements.define('full-outfit', FullOutfit);
  })